import { FormVmItemConfigType } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../../infrastructure/utils/form-config.utils';
import { trimSpacesLeft } from '../../../../../../../../modules/formatters';
import { urlValidator } from '../../../../../../../../modules/passport-pages/config';
import { plainText, requiredValidator } from '../../../../../../../../modules/validators';
import { ATTENDEE_EMAIL_TEXT, ATTENDEE_ID_TEXT, CONNECTION_ACCOUNT_TEXT, CONNECTION_LINK_TEXT, CONNECTION_PASSWORD_TEXT, PANELIST_LABEL_TEXT, PANELIST_WEBINAR_ID, PARTICIPANT_ID_TEXT } from '../../../../../_connections/connections.texts';

export enum PanelistLinkConnectionField {
    LABEL = 'label',
    WEBINAR_ID = 'connectionId',
    CONNECTION_LINK = 'connectionLink',
    CONNECTION_PASSWORD = 'connectionPassword',
    PARTICIPANT_ID = 'participantId',
    ATTENDEE_ID = 'attendeeId',
    CONNECTION_ACCOUNT = 'connectionAccount',
    ATTENDEE_EMAIL = 'attendeeEmail',
    CONNECTION_VERSION = 'connectionVersion',
    PARENT_MEETING_CONNECTION_ID = 'parentMeetingConnectionId',
    PARENT_JOIN_METHOD_ID = 'parentJoinMethodId',
    JOIN_METHOD_ID = 'joinMethodId'
}

export const FORM_CONFIG = {
    [PanelistLinkConnectionField.LABEL]: {
        labelDescriptor: PANELIST_LABEL_TEXT,
        validators: [plainText.maxLength.short],
        defaultValue: '',
    },
    [PanelistLinkConnectionField.WEBINAR_ID]: {
        labelDescriptor: PANELIST_WEBINAR_ID,
        defaultValue: '',
    },
    [PanelistLinkConnectionField.CONNECTION_LINK]: {
        labelDescriptor: CONNECTION_LINK_TEXT,
        validators: [requiredValidator, urlValidator],
        defaultValue: '',
    },
    [PanelistLinkConnectionField.CONNECTION_PASSWORD]: {
        labelDescriptor: CONNECTION_PASSWORD_TEXT,
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
        defaultValue: ''
    },
    [PanelistLinkConnectionField.PARTICIPANT_ID]: {
        labelDescriptor: PARTICIPANT_ID_TEXT,
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
        defaultValue: ''
    },
    [PanelistLinkConnectionField.ATTENDEE_ID]: {
        labelDescriptor: ATTENDEE_ID_TEXT,
        defaultValue: ''
    },
    [PanelistLinkConnectionField.CONNECTION_ACCOUNT]: {
        labelDescriptor: CONNECTION_ACCOUNT_TEXT,
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
        defaultValue: ''
    },
    [PanelistLinkConnectionField.ATTENDEE_EMAIL]: {
        labelDescriptor: ATTENDEE_EMAIL_TEXT,
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
        defaultValue: ''
    },
    [PanelistLinkConnectionField.CONNECTION_VERSION]: {
        defaultValue: ''
    },
    [PanelistLinkConnectionField.PARENT_MEETING_CONNECTION_ID]: {
        defaultValue: ''
    },
    [PanelistLinkConnectionField.PARENT_JOIN_METHOD_ID]: {
        defaultValue: ''
    },
    [PanelistLinkConnectionField.JOIN_METHOD_ID]: {
        defaultValue: ''
    },
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);